/* eslint-disable no-undef */
site = typeof (site) === 'undefined' ? {} : site;
site.constants = {
    globals : {
        homeItemId: document.querySelector("body").dataset.homeitemid,
        ctxItemId: document.querySelector("body").dataset.ctxitemid,
        ctxCulture: document.querySelector("body").dataset.ctxculture,
        antiforgeryToken: document.querySelector("body").dataset.antiforgerytoken 
    },   

    api: {       
        getalltrainingplaces: '/api/trainingplaces/all',
        login: '/api/login/'
    },
    "google-maps": {
        API_KEY: "AIzaSyAx5ZfIGE9k7Sex2CNTrCuzn46j9rPfN_0"
    }
};
